import { Injectable } from '@angular/core';

import { CompetitionRoute } from '@frontend/sports/navigation/core/feature/models';
import { MarketOfferUrlParam } from '@frontend/sports/navigation/core/feature/url-helper';

@Injectable({ providedIn: 'root' })
export class CompetitionGridHelper {
    getId(route?: CompetitionRoute): string {
        route = route || {};

        let id = route.sport!.toString();

        if (route.context) {
            id += `/${route.context}`;

            if (route.region) {
                id += `/regions/${route.region}`;
            }

            if (route.tournament) {
                id += `/tournaments/${route.tournament}`;
            }

            if (route.league) {
                id += route.isVirtual ? `/leagues/0:${route.league}` : `/leagues/${route.league}`;
            }

            if (route.virtualCompetitionGroup) {
                id += `/${route.virtualCompetitionGroup}`;
            }

            if (route.marketOffer) {
                if (route.marketOffer !== MarketOfferUrlParam.Gridable && route.marketOffer !== MarketOfferUrlParam.NonGridable) {
                    id += `/${route.marketOffer}`;
                }
            }
        }

        return id;
    }
}
